define('views/blocks/CustomBox42TutorialView',['underscore', 'jquery', 'backbone', 'SubView', 'app',
        'Siema',
        'template!blocks/product/custom-box-42-tutorial'
    ],
    function (_,$, Backbone,SubView,app,
              Siema,
              template){
        var steps, view, slider;
        return Backbone.View.extend({
            className:'custom-box-42__tutorial',
            events:{
              'click .custom-box-42__tutorial__cta':'nextStep',
              'click .custom-box-42__tutorial__pagination button':'goToStep',
              'click .btn-close':'close'
            },
            initialize:function(){
                view = this;
                steps = [
                    'Ajoutez vos produits en cliquant sur le "+"',
                    'Cliquez sur l\'image ou le nom du produit pour voir les ingrédients',
                    'Une fois votre box complète, passez à l\'étape suivante',
                    'Pas d\'inspiration aujourd\'hui ? Utilisez le bouton de composition aléatoire',
                ];
                steps = _(_.map(steps,function(label,i){
                    return {
                        label:app.t(label,'Product'),
                    }
                }));
                view.render();
            },
            render:function(){
                view.$el.html(template({steps:steps}));
                setTimeout(function(){
                    slider = new Siema({
                        selector: view.$('.siema').get(0),
                        duration: 200,
                        easing: 'ease-out',
                        perPage: 1,
                        startIndex: 0,
                        draggable: true,
                        multipleDrag: true,
                        threshold: 20,
                        loop: false,
                        onChange: function (){
                            view.onChangeSlide()
                        },
                    })
                },100)
            },
            nextStep:function(){
                if(slider.currentSlide === 3){
                    this.close();
                }else{
                    slider.next();
                }
            },
            goToStep:function(e){
                slider.goTo($(e.currentTarget).index());
            },
            close:function(){
                this.trigger('close',this);
            },
            onChangeSlide:function(){
                var view = this, currentSlide = slider.currentSlide,
                    ctaLabel = app.t(currentSlide===3 ? 'Composer ma box':'Suivant','Product');
                view.$('.custom-box-42__tutorial__pagination button').each(function(i){
                    $(this).toggleClass('active',i===currentSlide)
                })
                view.$('.custom-box-42__tutorial__cta').text(ctaLabel)
            },
        }).extend(SubView);
    });


